const getDisplayValue = (value, items) => {
  if (value && items){
    const found = items.find(element => element.value == value);
    if (found) return found.name;
  }
  return "";
};

export default getDisplayValue;